import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import { VERIFY_PAGE_URL} from '../../../constants';
import { tokenSelector, UserDataSelector} from '../../../store/selectors';
import * as actions from '../../../store/actions/index';
import React,{useState} from 'react';
import * as S from '../../../../../../verticals/hotels-dweb/src/shared/pages/ShareHotel/containers/ShareProperties.styles';
import Modal from '../../../../../../verticals/hotels-dweb/src/shared/components/Modal';
import * as action from '../../../../../onboarding/src/store/actions/onboarding';

function useRedirect()  {

  const [showModal, setShowModal] = useState(false);

  const token = useSelector(tokenSelector);
  const userData = useSelector(UserDataSelector);

  const history = useHistory();
  const dispatch = useDispatch();



    const successCallbacks = (refreshToken, status, response) => {
      dispatch(action.registerNewUserSuccess(userData, response.data));
      history.push(`${VERIFY_PAGE_URL}?t=${refreshToken}`);
    }

    const fcb = () => {
      history.push(`${VERIFY_PAGE_URL}?t=${token}`);
    }

    const setUserInfo = data => {

        let fd = new FormData();
        for (let key in data) {
          fd.append(key, data[key]);
        }
        fd.append('reverify', "true")
        fd.append('token', token)
        dispatch(actions.registerNewUserRedirectFlow(data, fd, (successCallbacks), fcb));
    };

    const closeModal = () => {
        setShowModal(false)
        setUserInfo(userData)
    }

    return [(
    <Modal hideCloseButton = {true} isOpen={showModal} closeModal={closeModal} modalStyles={{width: '40vw'}}>
    <S.ModalHeader>Session Expired</S.ModalHeader>
    <S.ModalContainer>
    <S.ModalContent minHeight='15rem' minPadding='1rem'>
    {(<>
      <S.AcknowledgeContainer minHeight='15rem'  minPadding='1rem' >
    <S.AcknowledgeText minPadding = '1rem' minMargin = '2rem'>Your session has expired. Click Continue to complete your sign-up</S.AcknowledgeText>
      <S.ModalButton onClick={closeModal}>Continue</S.ModalButton>
      </S.AcknowledgeContainer>
      </>) ||
      null}

      </S.ModalContent>
      </S.ModalContainer>
    </Modal>

    ),showModal, setShowModal]

  }

  export default (useRedirect)
